<template>
  <v-dialog
    v-model="isOpened"
    persistent
    width="680px"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-spacer />
        <v-btn icon @click="isOpened = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="px-3 pb-12">
        <v-row no-gutters justify="center" align="center">
          <v-icon x-large color="accent">verified_user</v-icon>
        </v-row>
        <v-row
          no-gutters
          justify="center"
          align="center"
          class="pt-4 font-weight-medium text-h6"
        >
          Votre compte Indeego a été migré vers votre nouvel espace
        </v-row>
        <v-row no-gutters justify="center" align="center" class="pt-4 text-subtitle-1">
          Veuillez noter l'adresse pour vous y connecter :
        </v-row>
        <v-row no-gutters justify="center" align="center" class="pt-3">
          <n-card depressed class="py-3 px-5 font-weight-bold primary--text">
            <v-row no-gutters justify="center" align="center">
              {{ globalBaseUrlLabel }}
              <v-btn :href="globalBaseUrl" target="_blank" icon x-small color="accent" class="ml-2">
                <v-icon>open_in_new</v-icon>
              </v-btn>
            </v-row>
          </n-card>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: [`value`],

  computed: {
    isOpened: {
      get() { return this.value; },
      set(isOpened) { this.$emit(`input`, isOpened); },
    },
    globalBaseUrl() {
      return window.INDEEGO_GLOBAL_BASE_URL;
    },
    globalBaseUrlLabel() {
      return this.globalBaseUrl.replace(/^.+\/\//g, ``);
    },
  },
};
</script>

<style lang="scss">
</style>
